if (!customElements.get('cobd-native-offer')) {
  customElements.define('cobd-native-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-native-offer-form]');
      this.button = this.querySelector('button[type="submit"]');
      this.error = this.querySelector('[data-offer-error]');
      this.form.addEventListener('submit', event => this.addOffer(event));
    }
    async addOffer(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const mainForm = document.getElementById(this.dataset.formId);
      const primary = mainForm?.querySelector('[name="id"]')?.value;
      const extra = this.querySelector('[data-extra]')?.value;
      if (!primary || !extra) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.error.hidden = true;
      let added = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const beforeResponse = await fetch(`${root}cart.js`);
        if (!beforeResponse.ok) throw new Error(this.dataset.error);
        const before = await beforeResponse.json();
        const isOwnAddonCode = code => /^COBD-(QWIK-\d+|CHAMELEON-15)$/i.test(code || '');
        const existingCodes = (before.discount_codes || []).map(code => code.code).filter(Boolean);
        const codes = new Set(existingCodes.filter(code => !isOwnAddonCode(code)));
        const discounts = [...(before.cart_level_discount_applications || []), ...(before.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
        discounts.filter(discount => discount?.type === 'discount_code').forEach(discount => existingCodes.push(discount.title));
        existingCodes.filter(code => !isOwnAddonCode(code)).forEach(code => codes.add(code));
        const replaceOwnCode = existingCodes.some(isOwnAddonCode);
        if (this.dataset.code && codes.size >= 5) throw new Error(this.dataset.codeLimitError);
        const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(primary),quantity:1},{id:Number(extra),quantity:1}]})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        if (this.dataset.code || replaceOwnCode) {
          if (this.dataset.code) codes.add(this.dataset.code);
          const discountResponse = await fetch(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:[...codes].join(',')})});
          if (!discountResponse.ok) throw new Error(this.dataset.discountError);
          const cart = await discountResponse.json();
          const applied = (cart.items || []).some(item => item.variant_id === Number(extra) && item.final_line_price < item.original_line_price);
          if (this.dataset.code && !applied) throw new Error(this.dataset.discountError);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = added ? this.dataset.discountError : `${error.message || ''} ${this.dataset.error}`;
        this.error.hidden = false;
        this.busy = added;
        this.button.disabled = added;
        this.button.textContent = this.dataset.ready;
        if (added) {
          const link = document.createElement('a');
          link.href = this.dataset.cartUrl;
          link.textContent = this.dataset.basketLabel;
          this.error.append(' ', link);
        }
      }
    }
  });
}
